export class referralUser {
    companyName: string;
    companyId: number;
    taxNumber: number;
    TotalReason: number;
    UserName: string;
    mobileNo: number;
    email: string;
    ReferralCode: number;
    StatusId: string;
    address: string;
    Longitude : any;
    Latitude : any;
    countryId: number;
    stateId: number;
    cityId: number;
    LocalityId: number;
    pincode: string;
    isCompany: boolean;
    BankName: string;
    id: number;
    BankDetailId: number;
    IFSCCode: string;
    AccountNumber: string;
    AccountHolderName: string;
    AccountType: string;
    MyReferralId: number;
    Reason: string;
    IsInternal: boolean;
    ReferBy: string;
    CreatedBy: number;
    percentage: number;
    // ContactPerson:string
}

export class bankDetails {
    id: number;
    referralUserId: number;
    ifscCode: string;
    accountNumber: string;
    accountHolderName: string;
    bankName: string;
    accountType: string;
    CreatedBy: number;
    branchName: string;
    CreatedDate: number;
    ModifiedBy: number;
    ModifiedDate: number
}

export class Person {
    value: boolean;
    viewValue: string;
}


export class FilterModel {
    StatusId: string;
    FromDate: Date;
    ToDate: Date;
}
